import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ExcelLocationImport_ModuleContextService } from './ExcelLocationImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ExcelLocationImport_warehouses_dd_ComponentContextService {
  private readonly moduleContext: ExcelLocationImport_ModuleContextService;

  constructor(moduleContext: ExcelLocationImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'warehouses_dd',
      type: ComponentType.selector
    }
  }
}